// {{ string | log }}
export default input => {
  console.log(input)
  return input
}
